import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
//import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { Router, NavigationExtras } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { DatePipe } from '@angular/common';
import * as moment from 'moment';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { ExportgridComponent } from '../../grid/exportgrid/exportgrid.component';
@Component({
  selector: 'app-activitylogreport',
  templateUrl: './activitylogreport.component.html',
  styleUrls: ['./activitylogreport.component.css']
})
export class ActivitylogreportComponent implements OnInit {

  @ViewChild('filterbar', { static: false }) filterbar;

  isadd: boolean = false;
  isedit: boolean = false;
  isdelete: boolean = false;
  isview: boolean = false;
  isprint: boolean = false;
  isexport: boolean = false;
  isfilter: boolean = false;


  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;


  formname: string = "ActivitylogReport";


  gridformtype: string = "";

  checkemp: string = "";
  companycheckColl: any = [];
  filterstatus: string = "ALL";
  activitylogColl: any = [];

  
  formColl: any = [];
  filteruserappform: string = "";


  fromdate: any = new Date();
  todate: any = new Date();

  searchtxt: any = "";

  columnDefs = [
    { headerName: 'Form', field: 'logat' },
    { headerName: 'Action', field: 'logtype' },
    { headerName: 'User', field: 'logby' },
    { headerName: 'Logon', field: 'logon', type: 'date' },
    { headerName: 'References', field: 'refnum' },
    { headerName: 'Description', field: 'logdescr' },
    { headerName: 'IpAddress', field: 'ipaddress' },
  ]

  gridOptions = {
    enableactioncol: false,
    columnDefs: this.columnDefs,
  };

  dateCustomClasses: DatepickerDateCustomClasses[];


  constructor(private appService: DhukanDataService, public router: Router, private productFindService: NgbModal,private datePipe: DatePipe,
    private confirmationDialogService: ConfirmationDialogService, private toastr: ToastrService, public loginService: LoginDataService){
    this.fnServiceChanges();

    this.dateCustomClasses = [
      { date: new Date(), classes: ['bg-warning'] },
    ];
    //this.fromdate.setDate(this.fromdate.getDate() - 15);
  }

  //Company Check
  fnServiceChanges(){
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
          if(this.loginService.fnCheckUser()){                
              this.fnCheckPrivilage();
              if(this.isview){
                this.isloading=true;
                this.fnOnInitForm();
              }
              else{
                this.fnUserFailedForm();
              }    
          }
          else{
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
    });
  }


  ngOnInit() {
    try{
      if (this.loginService.fnCheckCompany()) {
      if(this.loginService.fnCheckUser()){         
        this.fnCheckPrivilage();
        if(this.isview){
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }          
      }
      else{
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
  }
  fnOnInitForm() {
  
    this.fngetForms();
  }


  fnCheckPrivilage() {

    this.isadd = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE');
    this.isedit = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER');
    this.isdelete = this.loginService.fnCheckUserRoleAction(this.formname, 'DELETE');
    this.isview = this.loginService.fnCheckUserRoleAction(this.formname, 'VIEW');
    this.isprint = this.loginService.fnCheckUserRoleAction(this.formname, 'PRINT');
    this.isexport = this.loginService.fnCheckUserRoleAction(this.formname, 'EXPORT');


  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }






  //Get
  fngetForms() {
    var data = {
      'userappformid': 0,

    }

    this.appService.getUserappform(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.formColl = res.json().result;
            if (this.formColl.length > 0) {
              this.filteruserappform = this.formColl[0].userappformname;
              this. fngetActivitylogReport();
              }
          } else {
          
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get
  fngetActivitylogReport() {
    var data = {
      'logid': 0,
      'userappformname': this.filteruserappform,
      'companyid': this.loginService.fnGetCompanyId(),
      'fromdate': this.fnFormatDatetime(this.fromdate),
      'todate': this.fnFormatDatetime(this.todate),
    }
  
    this.appService.getActivitylogReport(data)
      .subscribe(
        (res) => {

          if (res.json().status === 200) {
            this.activitylogColl = res.json().result;
          } else {
            // this.loginService.fnAPIError(res.json())
          }
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }







  fnSetTable() {

  }

  private fnFocusTableRow(index, status) {
    if (index > -1) {
      if (status === 'IN') {
        this.activitylogColl[index].hoverfocus = "IN"
      }
      else {
        this.activitylogColl[index].hoverfocus = ""
      }
    }
  }

  fnTabHeaderClick(type) {
    this.searchtxt = "";
    this.gridformtype = type;
  }

  fnCloseForm() {
    try {
      this.router.navigate(['/Report']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnMomentDateTimeFormatter(params) {
    if (params.value) {
      return moment(params.value).format('DD-MM-YYYY hh:mm a');//  
    }
    else {
      return '';
    }

  }
  fnFormatDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        return this.datePipe.transform(dt, "yyyy-MM-dd")
      }

    } else {
      return null
    }

  }
  fnConvertDatetime(dt) {
    if (dt) {
      if (dt === "") {
        return null
      }
      else {
        var dateParts = dt.split("-");
        var sdate = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2] + 1);
        sdate.setMinutes(sdate.getMinutes() + sdate.getTimezoneOffset());
        return sdate;
      }

    } else {
      return null
    }

  }
  fnActionExportClick()  {
    const modalRef = this.productFindService.open(ExportgridComponent, { size: <any>'xxl', backdrop: 'static' });
    modalRef.componentInstance.doctype = this.formname;
    modalRef.componentInstance.columnDefs = this.columnDefs;
    modalRef.componentInstance.contentColl = this.activitylogColl;
    modalRef.componentInstance.fnSetTable();
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {
  
    
    });
  }
  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }

  private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }








}
